const _file_types = ['photo', 'pdf', 'document_scan'] as const;
export type _FileTypesTuple = typeof _file_types;
export type FileType = _FileTypesTuple[number];
export const ALLOWED_FILE_TYPES: ReadonlyArray<FileType> = _file_types;


type Options<Type, Excl> = {
  [Property in keyof Type as Exclude<Property, Excl>]: Type[Property];
};

export class MimeType {
  // constructor(
  //     public fileType: FileType,
  //     public fileExtensions: string[],
  //     public contentTypes: string[]
  // ) {}
  public fileType: FileType
  public fileExtensions: string[]
  public contentTypes: string[]

  constructor(obj: Options<MimeType, 'accept'>) {
    this.fileType = obj.fileType;
    this.fileExtensions = obj.fileExtensions;
    this.contentTypes = obj.contentTypes;
  }

  accept(): string {
    return this.fileExtensions.concat(this.contentTypes).join(',');
  }
}


export const fileTypeToMimeType: Immutable<Record<FileType, MimeType>> = {
  photo: new MimeType({
    fileType: "photo",
    fileExtensions: ['jpeg', 'jpg', 'png'],
    contentTypes: ['image/jpeg', 'image/png'],
  }),
  pdf: new MimeType({
    fileType: "pdf",
    fileExtensions: ['pdf'],
    contentTypes: ['application/pdf'],
  }),
  document_scan: new MimeType({
    fileType: "document_scan",
    fileExtensions: ['pdf', 'jpg', 'png'],
    contentTypes: ['application/pdf', 'image/jpeg', 'image/png'],
  }),
};
